import React from 'react';
import red from '@material-ui/core/colors/red';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { ValidatorComponent } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const red300 = red['500'];

const style = {
    right: 0,
    fontSize: '12px',
    color: red300,
    position: 'absolute',
    marginTop: '-25px',
};

class FakeRadioValidatorElement extends ValidatorComponent {
    componentDidUpdate(prevProps) {
        //console.log(this.props.name + "    " + this.props.value);
    }

    render() {
        const { errorMessages, validators, requiredError, value, ...rest } = this.props;
        // answerFalse="No" answerTrue="Yes" propName="termTimeAddressDifferent" currentValue={this.state.termTimeAddressDifferent} question="My term time address will be different to the specified address" setAnswer={this.handleDiffrentTermTimeAddressChange} 
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <Typography>{this.props.question}</Typography>
                </Grid>
                <Grid item xs={12} style={{ marginLeft: '10px' }}>

                    <RadioGroup
                        name={this.props.name}
                        value={this.props.value === undefined ? undefined : this.props.value.toString()}
                        onChange={this.props.handleChange}
                        readOnly="readOnly"
                        name={rest.name}
                        children={rest.children}
                        ref={(r) => { this.input = r; }}
                    >
                        <FormControlLabel value="true" disabled control={<Radio />} label={this.props.trueLabel} />
                        <FormControlLabel value="false" disabled control={<Radio />} label={this.props.falseLabel} />
                    </RadioGroup>
                    {this.errorText()}
                </Grid>
            </React.Fragment>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div style={style}>
                {this.getErrorMessage()}
            </div>
        );
    }
}

export default FakeRadioValidatorElement;